"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widthWithMinMaxPropTypes = exports.widthPropTypes = exports.statusPropTypes = exports.spacingPropTypes = exports.radiusPropTypes = exports.minWidthPropTypes = exports.marginPropTypes = exports.heightWithMinMaxPropTypes = exports.formElementPropTypes = exports.fontPropTypes = exports.flexShrinkPropTypes = exports.flexPropTypes = exports.flexAttributesPropTypes = exports.displayPropTypes = exports.disabledPropTypes = exports.colorPropTypes = exports.borderPropTypes = exports.backgroundColorPropTypes = exports.alignSelfPropTypes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _cssPropTypes = require("./cssPropTypes");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var backgroundColorPropTypes = {
  backgroundColor: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'background-color' property for the element.")
};
exports.backgroundColorPropTypes = backgroundColorPropTypes;
var borderPropTypes = {
  border: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'border' property for the element.")
};
exports.borderPropTypes = borderPropTypes;
var colorPropTypes = {
  color: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'color' property for the element.")
};
exports.colorPropTypes = colorPropTypes;
var radiusPropTypes = {
  borderRadius: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'border-radius' property for the element.")
};
exports.radiusPropTypes = radiusPropTypes;
var displayPropTypes = {
  display: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'display' property for the element.")
};
exports.displayPropTypes = displayPropTypes;
var fontPropTypes = {
  font: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'font-family' property for the element. Only supports named fonts from the Theme."),
  fontWeight: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'font-weight' property for the element. Only supports named font weights from the Theme."),
  fontSize: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'font-size' property for the element."),
  fontStyle: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'font-style' property for the element.")
};
exports.fontPropTypes = fontPropTypes;
var marginPropTypes = {
  margin: (0, _cssPropTypes.cssMargin)().description("Sets the CSS 'margin' property for the element.")
};
exports.marginPropTypes = marginPropTypes;

var spacingPropTypes = _objectSpread(_objectSpread({}, marginPropTypes), {}, {
  padding: (0, _cssPropTypes.cssPadding)().description("Sets the CSS 'padding' property for the element.")
});

exports.spacingPropTypes = spacingPropTypes;
var disabledPropTypes = {
  disabled: _stencilReactDesc.PropTypes.bool.description('Prevents the user from interacting with the field.'),
  readOnly: _stencilReactDesc.PropTypes.bool.description('Prevents the user from editing the content.')
};
exports.disabledPropTypes = disabledPropTypes;

var statusPropTypes = _objectSpread(_objectSpread({}, disabledPropTypes), {}, {
  warning: _stencilReactDesc.PropTypes.bool.description("Styles the field to indicate that it requires the user's attention."),
  error: _stencilReactDesc.PropTypes.bool.description('Styles the field to indicate that the value is incorrect and cannot be used.')
});

exports.statusPropTypes = statusPropTypes;

var formElementPropTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, backgroundColorPropTypes), colorPropTypes), displayPropTypes), fontPropTypes), spacingPropTypes), statusPropTypes);

exports.formElementPropTypes = formElementPropTypes;
var flexPropTypes = {
  flex: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'flex' property for the element.")
};
exports.flexPropTypes = flexPropTypes;
var flexShrinkPropTypes = {
  flexShrink: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'flexShrink' property for the element.")
};
exports.flexShrinkPropTypes = flexShrinkPropTypes;
var alignSelfPropTypes = {
  alignSelf: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'align-self' property for the element.")
};
exports.alignSelfPropTypes = alignSelfPropTypes;

var flexAttributesPropTypes = _objectSpread(_objectSpread(_objectSpread({}, flexPropTypes), alignSelfPropTypes), {}, {
  justifyContent: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'justify-content' property for the element."),
  alignItems: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'align-items' property for the element."),
  flexDirection: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'flex-direction' property for the element."),
  flexWrap: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'flex-wrap' property for the element.")
});

exports.flexAttributesPropTypes = flexAttributesPropTypes;
var widthPropTypes = {
  width: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'width' property for the element.")
};
exports.widthPropTypes = widthPropTypes;
var minWidthPropTypes = {
  minWidth: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'min-width' property for the element.")
};
exports.minWidthPropTypes = minWidthPropTypes;

var widthWithMinMaxPropTypes = _objectSpread(_objectSpread(_objectSpread({}, widthPropTypes), minWidthPropTypes), {}, {
  maxWidth: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'max-width' property for the element.")
});

exports.widthWithMinMaxPropTypes = widthWithMinMaxPropTypes;
var heightWithMinMaxPropTypes = {
  height: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'height' property for the element."),
  minHeight: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'min-height' property for the element."),
  maxHeight: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'max-height' property for the element.")
};
exports.heightWithMinMaxPropTypes = heightWithMinMaxPropTypes;